---
fr:
  errors:
    messages:
      carrierwave_download_error: n'a pas pu être téléchargé
      carrierwave_integrity_error: n'est pas d'un type de fichier autorisé
      carrierwave_processing_error: n'a pas pu être traité
      content_type_blacklist_error: Vous n'êtes pas autorisé à téléverser des fichiers %{content_type}
      content_type_whitelist_error: 'Vous n''êtes pas autorisé à téléverser des fichiers %{content_type}, types autorisés : %{allowed_types}'
      extension_blacklist_error: 'Vous n''êtes pas autorisé à téléverser des fichiers %{extension}, types interdits : %{prohibited_types}'
      extension_whitelist_error: 'Vous n''êtes pas autorisé à téléverser des fichiers %{extension}, types autorisés : %{allowed_types}'
      max_size_error: La taille du fichier doit être inférieure à %{max_size}
      min_size_error: La taille du fichier doit être supérieure à %{min_size}
      mini_magick_processing_error: 'Échec de la manipulation avec MiniMagick, peut-être que ce n''est pas une image ? Erreur d''origine : %{e}'
      rmagick_processing_error: Échec de la manipulation avec rmagick, peut-être que ce n'est pas une image ?
